import { Element, useNode } from "@craftjs/core";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import RichText from "@/components/editor/primitives/rich-text";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";

import { DEFAULT_CONTENT } from "./constants";
import { Wrapper } from "./rich-text-section-component-styles";

export default function RichTextSection() {
  const {
    id,
    connectors: { connect },
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={id}>
      <BlockMaxWidthWrapper>
        <Wrapper>
          <Element
            id="rich-text-section"
            is={RichText}
            text={DEFAULT_CONTENT}
          />
        </Wrapper>
      </BlockMaxWidthWrapper>
    </BlockBackgroundColorWrapper>
  );
}

RichTextSection.craft = {
  custom: {
    displayName: "Rich text section",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
